export default function workspaceNotificationCards(state = [], action) {
  switch (action.type) {
    case 'WORKSPACE_NOTIFICATION_CARD_PUT_RESPONSE':
      return state.map(workspace_notification_card => {
        if (workspace_notification_card.id === action.payload.id)
          return { ...workspace_notification_card, ...action.payload };
        return workspace_notification_card;
      });
    case 'WORKSPACE_NOTIFICATION_CARDS_GET_RESPONSE':
      return action.payload;
    default:
      return state;
  }
}
